import { Injectable } from '@angular/core';
import { ResourcesService } from '../resources.service';
import {UserService} from '../user/user.service';
import {Notification} from '../../model/notification';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class NotificationsService {

  constructor(private _resources: ResourcesService, private _userService: UserService) { }

  getNotificationsList() {
    return this._resources.get(
      'notification/AgentList?agentId=' + this._userService.userAccountTypeDefault.agent.id,
      true,
      undefined
    );
  }

  markAsRead(notification: Notification) {
    return this._resources.post('notification/MarkAsRead',
      {
        userAccountId: this._userService.userAccount.id,
        notification: notification
      }
    );
  }

  markAllAsRead(notifications: Notification[]) {
    return this._resources.post(
      'notification/markAllAsRead',
      {
        // by: '',
        userAccountId: this._userService.userAccount.id,
        notifications: notifications
      }
    );
  }

  markAsDeleted(notification: Notification) {
    return this._resources.post('notification/MarkAsDeleted',
      {
        userAccountId: this._userService.userAccount.id,
        notification: notification
      }
    );
  }

  markAllAsDeleted(notifications: Notification[]) {
    return this._resources.post(
      'notification/MarkAllAsDeleted',
      {
        // by: '',
        userAccountId: this._userService.userAccount.id,
        notifications: notifications
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/notifications/notifications.service.ts